<script setup>
import { useI18n } from 'vue-i18n';

import Icon from 'next/icon/Icon.vue';

const { t } = useI18n();
</script>

<template>
  <div class="my-auto flex flex-col items-center gap-2 text-center">
    <Icon
      icon="i-lucide-messages-square"
      class="text-n-slate-11 size-10 mb-2"
    />
    <h1 class="text-xl">
      {{
        t(
          'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_MANAGER.CHAT_SECTION.EMPTY_STATE.TITLE'
        )
      }}
    </h1>
    <p class="text-sm text-n-slate-10">
      {{
        t(
          'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_MANAGER.CHAT_SECTION.EMPTY_STATE.DESCRIPTION'
        )
      }}
    </p>
  </div>
</template>
